<template>
  <div>
    <div class="d-flex justify-content-between mb-3">
      <div class="title">Material Request</div>
    </div>
    <div v-if="!occurrence.materialRequestGuid">
      <div class="alert alert-info">
        <p>This technical occurrence is not linked to a material request.</p>
      </div>

      <p class="mt-3">
        <button class="badgebutton active" @click="createMaterialRequest">
          <i class="far fa-plus"></i>
          Create Material Request
        </button>
      </p>
    </div>
    <div v-else>
      <div class="alert alert-success">
        <p>This technical occurrence is linked to Material Request: {{ materialRequest.name }}</p>
      </div>

      <p class="mt-3">
        <button class="badgebutton active" @click="navigateMaterialRequest">
          <i class="far fa-link"></i>
          Go to Material Request
        </button>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { SpecialOccurrenceModule, SpecialOccurrenceStore } from '@/store/specialOccurrence';
  import TaskCard from '@/components/TaskCard.vue';
  import { MaterialRequestDto, SpecialOccurrenceAccessLevel, TechnicalOccurrenceDto } from '@/apiclient/apiclient_generated';
  import LoadingSpinner from '@/components/Misc/LoadingSpinner.vue';
  import { materialRequestClient } from '@/apiclient/opsboardapi';

  @Component({
    components: {
      TaskCard,
      LoadingSpinner,
    },
  })
  export default class MaterialRequestLink extends Vue {
    private store: SpecialOccurrenceModule = SpecialOccurrenceStore;
    materialRequest: MaterialRequestDto = MaterialRequestDto.fromJS({ name: 'unknown' });

    async mounted() {
      if (this.occurrence.materialRequestGuid) {
        this.materialRequest = await materialRequestClient.getById(this.occurrence.materialRequestGuid);
      }
    }

    get occurrence(): TechnicalOccurrenceDto {
      return this.store.currentOccurrence;
    }

    navigateMaterialRequest() {
      this.$router.push({ name: 'MaterialRequestLinkIntermediate', params: { id: this.occurrence.materialRequestGuid } });
    }

    async createMaterialRequest() {
      this.materialRequest = await materialRequestClient.createFromTechnicalOccurrence(this.occurrence.id);
      this.$router.push({ name: 'MaterialRequestLinkIntermediate', params: { id: this.materialRequest.id } });
    }

    get userCanEdit() {
      return (
        this.store.currentOccurrenceUserAccessLevel == SpecialOccurrenceAccessLevel.Admin ||
        this.store.currentOccurrenceUserAccessLevel == SpecialOccurrenceAccessLevel.Editor
      );
    }
  }
</script>

<style scoped lang="scss">
  .title {
    font-weight: bold;
    font-size: 1.1rem;
    text-decoration: none;
  }
</style>
